import { InteriorDamaged } from './InteriorDamage';
import { InteriorLevel3 } from './InteriorGeneral';
import { PowerEquipment } from './PowerEquipment';

export const Interior = () => {
  return (
    <>
      <InteriorLevel3 />
      <PowerEquipment />
      <InteriorDamaged />
    </>
  );
};
